/* eslint-disable check-credentials-option/has-credentials-option */
import { cfetch } from '@confluence/network';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';
import { isLocal } from '@confluence/ssr-utilities/entry-points/env.ts';

import { createCookie } from './createCookie.ts';

interface FetchORSType {
	userContext: string | undefined;
	url: string;
	body: string;
}

const OBJECT_RESOLVER_SERVICE_NAME = 'object-resolver-service';
const OBJECT_RESOLVER_SERVICE_ARCHETYPE_NAME = 'object-resolver-service-archetype';

export const fetchORSForSSR = async ({ url, userContext, body }: FetchORSType): Promise<any> => {
	const { host, cloudId, isBifrostIcRequest } = getSSRRenderInputs();
	const fetchOptions = {
		method: 'POST',
		headers: {
			Cookie: createCookie(userContext),
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Origin: host.startsWith('http') ? host : `https://${host}`,
			CloudId: cloudId,
			'X-Product': 'CONFLUENCE',
			// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
			...(Boolean(process.env.REACT_SSR) &&
			Boolean(process.env.BIFROST_TEMPLATE_BUILD) &&
			!isLocal()
				? {
						'x-ssr-service-name': OBJECT_RESOLVER_SERVICE_NAME,
						...(isBifrostIcRequest === true
							? { 'x-archetype-name': OBJECT_RESOLVER_SERVICE_ARCHETYPE_NAME }
							: {}),
					}
				: {}),
		},
		body,
	};

	return cfetch(url, fetchOptions);
};
